import React, { useEffect, useRef } from 'react';
import '../styles/Hero.css';

const CLIENT_LOGOS = [
  'Django',
  'Rails',
  'React',
  'Next.js',
  'PostgreSQL',
  'AWS',
  'Docker',
  'Stripe',
  'Shopify',
  'OpenAI',
];

const Hero = () => {
  const heroRef = useRef(null);

  useEffect(() => {
    const el = heroRef.current;
    if (!el) return;
    requestAnimationFrame(() => el.classList.add('is-ready'));
  }, []);

  const scrollTo = (e, id) => {
    e.preventDefault();
    const element = document.getElementById(id);
    if (!element) return;
    const top = element.getBoundingClientRect().top + window.pageYOffset - 88;
    window.scrollTo({ top, behavior: 'smooth' });
  };

  return (
    <section id="home" className="hero" ref={heroRef}>
      <div className="hero-bg" aria-hidden="true">
        <div className="hero-orb hero-orb--a" />
        <div className="hero-orb hero-orb--b" />
      </div>

      <div className="container hero-grid">
        <div className="hero-copy">
          <h1 className="hero-title">
            <span>Building Digital</span>
            <span>Products That</span>
            <span className="hero-title-script">Matter</span>
          </h1>

          <p className="hero-lead">
            Trusted by teams shipping production software — with{' '}
            <strong>5+</strong> years as a Senior Full-Stack Developer, boosting delivery
            speed by <strong>30%</strong>, reliability by <strong>55%</strong>, and systems
            used across <strong>10K+</strong> users.
          </p>

          <div className="hero-actions">
            <a href="#projects" className="btn btn--ghost" onClick={(e) => scrollTo(e, 'projects')}>
              <span className="hero-play" aria-hidden="true" />
              Show Work
            </a>
            <a href="#contact" className="btn btn--primary" onClick={(e) => scrollTo(e, 'contact')}>
              Hire Me
            </a>
          </div>

          <p className="hero-worked">Worked with modern stacks & platforms</p>
          <div className="hero-marquee" aria-hidden="true">
            <div className="hero-marquee-track">
              {[...CLIENT_LOGOS, ...CLIENT_LOGOS].map((logo, i) => (
                <span key={`${logo}-${i}`} className="hero-logo-chip">
                  {logo}
                </span>
              ))}
            </div>
          </div>
        </div>

        <div className="hero-visual">
          <div className="hero-portrait">
            <div className="hero-portrait-ring" aria-hidden="true" />
            <div className="hero-portrait-core">
              <img
                src="/images/muqeet.png"
                alt="Muqeet Ahmad"
                className="hero-portrait-img"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
